import api from './api';

export interface GlobalSearchResult {
  projects: Array<{ project_id: string; project_name: string; client_name?: string; contract_number?: string; project_phase?: string }>;
  offers: Array<{ offer_id: string; project_id: string; contractor_name?: string; status?: string; package_name?: string }>;
  inquiries: Array<{ inquiry_id: string; project_id: string; subject?: string; status?: string; contractor_email?: string; project_name?: string; package_name?: string }>;
  orders: Array<{ id: number; order_id_display?: string; project_id: string; contractor?: string; status?: string }>;
  contractors: Array<{ id: string; name: string; nip?: string; email?: string; phone?: string; industry?: string; location?: string }>;
  subcontractors: Array<{ id: string; name: string; project_id?: string; contract_number?: string; contract_subject?: string }>;
}

export const searchService = {
  async global(query: string, limit: number = 5): Promise<GlobalSearchResult> {
    const resp = await api.get('/search', { params: { q: query, limit } });
    return resp.data.data as GlobalSearchResult;
  }
};

export default searchService;


